<template>
  <div class="welcome">
    <div class="scroll-downs">
    <div class="mousey">
        <div class="scroller"></div>
      </div>
    </div>
    <img src="../assets/welcome.jpg" />
    <div class="tagline">
      <div style="font-size:medium;">Recording Studio near South Molton, Devon. </div>
      Recording &bull; Mixing &bull; Mastering
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome'
}
</script>

<style scoped lang="scss">
.welcome{
  
  height: 100vh;
  color:white;
}
.welcome img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-sizing: border-box;
}

.tagline{
  font-family: 'Source Sans Pro';
  background-color: rgba(0,0,0,0.8);
  color: white;
  font-size: x-large;
  text-align: center;
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  padding:0.5em;
  border-top: 2px solid rgba(0,0,0,0.8);
}


.scroll-downs {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  margin-top: 75vh;
  width :34px;
  height: 55px;
}
@media only screen and (max-width: 600px) {
  .scroll-downs{
    margin-top:65vh;
  }
}
.mousey {
  width: 3px;
  padding: 10px 15px;
  height: 35px;
  border: 2px solid #fff;
  border-radius: 25px;
  opacity: 0.75;
  box-sizing: content-box;
}
.scroller {
  width: 3px;
  height: 10px;
  border-radius: 25%;
  background-color: #fff;
  animation-name: scroll;
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(.15,.41,.69,.94);
  animation-iteration-count: infinite;
}
@keyframes scroll {
  0% { opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(15px); opacity: 0;}
}
</style>
